import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'dat.gui'
import { SphereGeometry } from 'three'


//Loading
const textureloader = new THREE.TextureLoader();
const normaltexture = textureloader.load("/textures/Normal.png");




// Debug
//const gui = new dat.GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

// Objects
const geometry = new THREE.SphereBufferGeometry(.5, 64, 64);

// Materials

const material = new THREE.MeshStandardMaterial();
material.metalness = 1;
material.roughness = 0.3;
material.normalMap = normaltexture;
material.color = new THREE.Color(0xffffff)

// Mesh
const sphere = new THREE.Mesh(geometry,material)
scene.add(sphere)

// Lights
/*
const pointLight = new THREE.PointLight(0xffffff, 0.01);
pointLight.position.x = 16
pointLight.position.y = 16
pointLight.position.z = 4
scene.add(pointLight)
*/
const pointLight2 = new THREE.PointLight(0xff1e, 2);
/*pointLight.position.x = 2
pointLight.position.y = 3
pointLight.position.z = 4*/
pointLight2.position.set(1.20, -1.25, -0.60);
pointLight2.intensity = 3.5;

scene.add(pointLight2);

// light3
const pointLight3 = new THREE.PointLight(0x1eff, 2);
/*pointLight.position.x = 2
pointLight.position.y = 3
pointLight.position.z = 4*/
pointLight3.position.set(-2.90, 3, -2);
pointLight3.intensity = 6;

scene.add(pointLight2);
scene.add(pointLight3);

/*
const light2 = gui.addFolder("Light 2");
light2.add(pointLight.position, "y").min(-3).max(16).step(0.01)
light2.add(pointLight.position, "x").min(-6).max(16).step(0.01)
light2.add(pointLight.position, "z").min(-3).max(16).step(0.01)
light2.add(pointLight, "intensity").min(0).max(10).step(0.01)

const light2color = {
    color: 0xff0000
}

light2.addColor(light2color, "color")
    .onChange(() => {
        pointLight2.color.set(light2color.color);
})



const light3 = gui.addFolder("Light 3");
light3.add(pointLight3.position, "y").min(-3).max(3).step(0.01)
light3.add(pointLight3.position, "x").min(-6).max(3).step(0.01)
light3.add(pointLight3.position, "z").min(-3).max(3).step(0.01)
light3.add(pointLight3, "intensity").min(0).max(10).step(0.01)

const light3color = {
    color: 0xff0000
}

light3.addColor(light3color, "color")
    .onChange(() => {
        pointLight3.color.set(light3color.color);
})
*/

/**
 * Sizes
 * Auto adjust of canvas to screen size
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.y = 0
camera.position.z = 2
scene.add(camera)

// Controls
// const controls = new OrbitControls(camera, canvas)
// controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
document.addEventListener("mousemove", onDocumentMouseMove);

let mouseX = 0;
let mouseY = 0;

let targetX = 0;
let targetY = 0;

const windowHalfX = window.innerWidth / 2;
const windowHalfY = window.innerHeight / 2;

function onDocumentMouseMove (event) {

    //smooth scroll
    mouseX = (event.clientX - windowHalfX);
    mouseY = (event.clientY - windowHalfY);
}

const clock = new THREE.Clock()

const tick = () =>
{
    targetX = mouseX * 0.01;
    targetY = mouseY * 0.01;


    const elapsedTime = clock.getElapsedTime()

    // Update objects
    sphere.rotation.y = 0.2 * elapsedTime

        // mouse movements
    sphere.rotation.y += .5 * (targetX - sphere.rotation.y);
    sphere.rotation.x += .05 * (targetY - sphere.rotation.x);
    sphere.rotation.z += -.05 * (targetY - sphere.rotation.x);


    // Update Orbital Controls
    // controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()